export default __webpack_public_path__ + "static/media/fooddiary_icon.9ea71fa1.png";